import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@icon/alertSprint2.svg'


const _hoisted_1 = { class: "label-pic is-red" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    projectName: _ctx.notification.projectName,
    showSubTitle: false,
    class: "notification__sync-error"
  }, {
    pic: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_icon, {
          data: _imports_0,
          class: "label-pic__icon",
          width: "var(--icon-24)",
          height: "var(--icon-24)"
        })
      ])
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "500"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Sprint Start Validation Error ")
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      (_ctx.sprintContent?.sprint?.sequenceNumber)
        ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
            key: 0,
            size: "medium",
            color: "monochrome-06",
            darkColor: "monochrome-03",
            weight: "400",
            className: "notification__update-item__description"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: _ctx.sprintContent.acceptanceUrl,
                class: "link .is-medium-500"
              }, "Sprint #" + _toDisplayString(_ctx.sprintContent.sprint.sequenceNumber), 9, _hoisted_2),
              _createTextVNode(" was started in Jira, but cannot be started in Project Simple due to validation errors. ")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_BaseSubHeading, {
            key: 1,
            size: "medium",
            color: "monochrome-06",
            darkColor: "monochrome-03",
            weight: "400",
            className: "notification__update-item__description"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sprint was started in Jira, but cannot be started in Project Simple due to validation errors. ")
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["notification", "projectName"]))
}